module.exports = __webpack_public_path__ + "public/images/partners/sup-13.358af036ec6673ff1ce275a37cb9a526.png";